export const addNextPage = (url) => {
    return {
        type: 'ADD-NEXT-PAGE',
        payload: url
    }
}

export const clearNextPage = () => {
    return {
        type: 'CLEAR-NEXT-PAGE'
    }
}